<link
  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined"
  rel="stylesheet"
/>

<div class="main-container">
  <div class="voucher-container">
    <div class="box-container">
      <div class="back-btn" (click)="closeVoucherInputMobile()">
        <img alt="Add circle icon" src="/assets/icons/arrow_circle_left.svg" />
        <span>Back</span>
      </div>

      <div class="title">
        <span>{{ "voucher.offer" | translate }}</span>
        <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="closeVoucherInput()"
        >
          <mat-icon>close_small</mat-icon>
        </button>
      </div>
      <span class="description">{{ "voucher.description" | translate }}</span>
    </div>

    <div class="scroll-box">
      <div class="input">
        <input
          class="codeInput"
          [placeholder]="'voucher.insertCode' | translate"
          [(ngModel)]="voucherCode"
        />
        <button type="button" mat-icon-button matSuffix [disabled]="!voucherCode?.trim()" (click)="applyCode()">
          <span class="button">{{ "voucher.apply" | translate }}</span>
        </button>
      </div>

      <div *ngIf="voucherErrorDesc" class="referralError">
        <mat-icon class="material-symbols-outlined" style="color: #e30a12"
          >error</mat-icon
        >
        <span>{{ voucherErrorDesc | translate }}</span>
      </div>

      <div class="box-container">
        <span class="title_second" style="color: #203570">{{
          "voucher.promoVoucher" | translate
        }}</span>
        <span class="error" *ngIf="promoErrorDesc">{{
          promoErrorDesc | translate
        }}</span>
        <div
          *ngIf="promoVoucherList?.length > 0; else noPromo"
          [ngClass]="{ disabled: disabledPromoVoucher }"
        >
          <div
            *ngFor="let promo of promoVoucherList;"
            style="margin-bottom: 12px; margin-top: 6px;"
          >
            <!-- <div
              class="cheapest-tag-wrap"
              [ngClass]="{ disabled: promo.disabled }"
              *ngIf="promo.isDrivePlusExclusive && !promo.fullyRedeemed"
            >
              <img
                *ngIf="translate.currentLang === 'en'"
                class="cheapest-tag"
                src="assets/image/exclusive-driveplus-member-en.png"
              />
              <img
                *ngIf="translate.currentLang !== 'en'"
                class="cheapest-tag"
                src="assets/image/exclusive-driveplus-member-bm.png"
              />
            </div> -->
            <label
              class="promoAvailable"
              [ngClass]="{
                disabled: promo.fullyRedeemed || promo.disabled,
                selected: selectedPromoVoucher === promo
              }"
              (dblclick)="handleDoubleClick($event, 'Promo', promo)"
            >
              <div class="icon-box" [ngClass]="{ 'make-icon': promo.make }">
                <img
                  alt="Promo voucher icon"
                  [style.width]="promo.make ? '44px' : null"
                  [src]="
                    promo.make
                      ? getMakeIcon(promo.make)
                      : '/assets/icons/promo-voucher.png'
                  "
                />
              </div>
              <div class="details">
                <div class="box">
                  <p
                    *ngIf="
                      promo.limit != null &&
                      !promo.fullyRedeemed &&
                      !promo.showRemainingBar
                    "
                    class="redemption"
                    [ngStyle]="{ 'margin-bottom': '3px' }"
                  >
                    {{ "voucher.limitedRedemption" | translate }}
                  </p>
                  <p class="name">{{ promo.name }}</p>
                  <p class="code">{{ promo.code }}</p>
                  <div
                    class="remaining-bar"
                    *ngIf="promo.showRemainingBar && !promo.fullyRedeemed"
                  >
                    <div class="remainingBar">
                      {{ promo.remainingPercentage }}%
                      {{ "voucher.remaining" | translate }}
                    </div>
                    <div class="remaining-bar-track">
                      <div
                        class="remaining-bar-fill"
                        [ngStyle]="{
                          width: promo.remainingPercentage + '%',
                          'background-color':
                            promo.remainingPercentage <= 5
                              ? '#FF832B'
                              : '#0091FF'
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="expired">
                  <img
                    alt="Hourglass icon"
                    class="expiredIcon"
                    src="/assets/icons/hourglass_red.png"
                  />
                  <span
                    >{{ "voucher.expiringOn" | translate }}
                    {{ promo.endDate | date : "d MMMM yyyy" }}</span
                  >
                </div>
              </div>
              <input
                type="radio"
                name="promoSelection"
                [value]="promo"
                [(ngModel)]="selectedPromoVoucher"
                class="radio-button"
                *ngIf="!promo.fullyRedeemed"
                (change)="handleClick($event, 'Promo')"
              />
              <div *ngIf="promo.fullyRedeemed" class="fullyRedeem">
                {{ "voucher.fullyRedeemed" | translate }}
              </div>
            </label>
          </div>
        </div>
        <ng-template #noPromo>
          <div class="voucherEmpty">
            {{ "voucher.noAvailableVoucher" | translate }}
          </div>
        </ng-template>
      </div>

      <div class="box-container">
        <span class="title_second" style="color: #24a148">{{
          "voucher.cashVoucher" | translate
        }}</span>
        <div
          *ngIf="cashVoucherList?.length > 0; else noVoucher"
          [ngClass]="{ disabled: false }"
        >
          <div *ngFor="let cash of cashVoucherList" style="margin-bottom: 12px; margin-top: 6px;">
            <!-- <div
              class="cheapest-tag-wrap"
              [ngClass]="{ disabled: cash.disabled }"
              *ngIf="cash.isDrivePlusExclusive && !cash.fullyRedeemed"
            >
              <img
                *ngIf="translate.currentLang === 'en'"
                class="cheapest-tag"
                src="assets/image/exclusive-driveplus-member-en.png"
              />
              <img
                *ngIf="translate.currentLang !== 'en'"
                class="cheapest-tag"
                src="assets/image/exclusive-driveplus-member-bm.png"
              />
            </div> -->
            <label
              class="voucherAvailable"
              [ngClass]="{
                disabled: cash.fullyRedeemed || cash.disabled,
                selected: selectedCashVoucher === cash
              }"
              (dblclick)="handleDoubleClick($event, 'Cash', cash)"
            >
              <div class="icon-box" [ngClass]="{ 'make-icon': cash.make }">
                <img
                  alt="Cash voucher icon"
                  [style.height]="cash.make ? null : '35.38px'"
                  [style.width]="cash.make ? '44px' : null"
                  [src]="
                    cash.make
                      ? getMakeIcon(cash.make)
                      : '/assets/icons/cash-voucher.png'
                  "
                />
              </div>
              <div class="details">
                <div class="box">
                  <p
                    *ngIf="
                      cash.limit != null &&
                      !cash.fullyRedeemed &&
                      !cash.showRemainingBar
                    "
                    class="redemption"
                    [ngStyle]="{ 'margin-bottom': '3px' }"
                  >
                    {{ "voucher.limitedRedemption" | translate }}
                  </p>
                  <p class="name">{{ cash.name }}</p>
                  <p class="code">{{ cash.code }}</p>
                  <div
                    class="remaining-bar"
                    *ngIf="cash.showRemainingBar && !cash.fullyRedeemed"
                  >
                    <div class="remainingBar">
                      {{ cash.remainingPercentage }}%
                      {{ "voucher.remaining" | translate }}
                    </div>
                    <div class="remaining-bar-track">
                      <div
                        class="remaining-bar-fill"
                        [ngStyle]="{
                          width: cash.remainingPercentage + '%',
                          'background-color':
                            cash.remainingPercentage <= 5
                              ? '#FF832B'
                              : '#0091FF'
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="expired">
                  <img
                    alt="Hourglass icon"
                    class="expiredIcon"
                    src="/assets/icons/hourglass_red.png"
                  />
                  <span
                    >{{ "voucher.expiringOn" | translate }}
                    {{ cash.endDate | date : "d MMMM yyyy" }}</span
                  >
                </div>
              </div>
              <input
                type="radio"
                name="cashSelection"
                [value]="cash"
                [(ngModel)]="selectedCashVoucher"
                class="radio-button"
                *ngIf="!cash.fullyRedeemed"
                (change)="handleClick($event, 'Cash')"
              />
              <div *ngIf="cash.fullyRedeemed" class="fullyRedeem">
                {{ "voucher.fullyRedeemed" | translate }}
              </div>
            </label>
          </div>
        </div>
        <ng-template #noVoucher>
          <div class="voucherEmpty">No vouchers available</div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="total-container">
    <div
      *ngIf="selectedCashVoucher || selectedPromoVoucher"
      class="selectedVoucher"
      [ngStyle]="{ display: 'flex' }"
    >
      <div>
        <span *ngIf="selectedCashVoucher || selectedPromoVoucher">
          {{ (selectedCashVoucher ? 1 : 0) + (selectedPromoVoucher ? 1 : 0) }}
          {{ "voucher.voucherDiscountApplied" | translate }}</span
        >
      </div>
      <span class="discountPrice">
        -RM{{ finalDiscountAmount | number : "1.2-2" }}</span
      >
    </div>
    <div class="box-container">
      <span class="title">{{ "voucher.totalAmount" | translate }}</span>
      <span class="value"
        >RM {{ finalAmountAfterDiscount | number : "1.2-2" }}</span
      >
    </div>
    <button type="button" mat-icon-button matSuffix (click)="applyVoucher()">
      {{ "voucher.continue" | translate }}
    </button>
  </div>
</div>
